<template>
  <div>
    <!-- STANDARD NAV -->
    <nav v-if="$whitelabel.short.toLowerCase() !== 'adac'" class="navbar" role="navigation" aria-label="main navigation"
      v-bind:class="{ 'is-fixed-top': $whitelabel.fixedNavbar }">
      <button class="skip-to-main focus-visible-only button is-dark " @click="scrollToMainContent">{{
        $t('general.to-main-content') }}</button>
      <div class="container">
        <div class="navbar-brand">
          <a id="nav-search" v-if="$whitelabel.short.toLowerCase() !== 'greenstorm' && $whitelabel.logoHeaderLink"
            class="navbar-item navbar-item--brand" :href="$whitelabel.logoHeaderLink" target="_blank" rel="noopener"
            aria-label="Homepage">
            <NavHomeBrand />
          </a>
          <router-link id="nav-search" v-else-if="$whitelabel.short.toLowerCase() !== 'greenstorm'"
            class="navbar-item navbar-item--brand" :to="{ name: 'home' }" aria-label="Homepage"
            @click.native="resetSearchAndLoadProducts">
            <NavHomeBrand />
          </router-link>

          <div class="navbar-item is-block" v-if="$whitelabel.short.toLowerCase() == 'greenstorm'">
            <router-link id="nav-search" :to="{ name: 'home' }" aria-label="Homepage"
              @click.native="resetSearchAndLoadProducts">
              <img fetchpriority="high" class="navbar-brand__logo is-block" :src="$whitelabel.logoHeader"
                :alt="$whitelabel.storeName" v-if="$whitelabel.showHeaderLogo" />
              <span v-if="!$whitelabel.showHeaderLogo" class="is-hidden-touch"><b-icon icon="search"
                  size="is-small"></b-icon> &nbsp;{{ $t('general.find-vacation') }}</span>
            </router-link>

            <div class="has-text-centered is-hidden-touch">
              <a href="https://greenstorm.eu/" title="zurück zur Hauptseite"> <b-icon icon="chevron-left">
                </b-icon>zurück zur Hauptseite</a>
            </div>
          </div>

          <router-link v-if="$whitelabel.showHeaderSearchDesktop" id="nav-search" class="navbar-item is-hidden-touch"
            :to="{ name: 'home' }" aria-label="Homepage" @click.native="resetSearchAndLoadProducts">
            <b-icon icon="search" size="is-small"></b-icon> {{ $t('general.find-vacation')
            }}
          </router-link>

          <!--no homepage & mobile-->
          <div class="navbar-item is-hidden-desktop u-ml-auto" v-if="!pendingContent && home.length == 0">
            <!-- <a @click="openSearchModal"> <b-icon icon="search" size="is-small"></b-icon>  </a> -->
            <router-link :to="{ name: 'home' }">
              <b-icon icon="search" size="is-small"></b-icon> <span class="sr-only">{{ $t('general.find-vacation')
              }}</span></router-link>
          </div>

          <!--with homepage & mobile-->
          <div class="navbar-item is-hidden-desktop u-ml-auto" v-if="!pendingContent && home.length > 0">
            <router-link v-if="!pendingContent && home.length > 0" :to="{ name: 'search' }">
              <b-icon icon="search" size="is-small"></b-icon> <span class="sr-only">{{ $t('general.find-vacation')
              }}</span></router-link>
          </div>

          <!-- <div class="navbar-item is-hidden-desktop" v-if="$whitelabel.isStandalone">
            <router-link
              :to="{
                name: 'account',
              }"
            >
              <b-icon icon="user" size="is-small"></b-icon>
              <small v-if="hasUser" class="is-hidden-touch">
                <strong>({{ userName }})</strong>
              </small>
            </router-link>
          </div> -->
          <div v-if="!$whitelabel.hideLogin" class="navbar-item is-hidden-desktop">
            <router-link :to="{
              name: 'userorders',
            }">
              <b-icon v-if="!hasUser" icon="user" size="is-small"></b-icon>
              <b-icon v-if="hasUser" icon="user-cog" size="is-small"></b-icon>
              <span class="sr-only">Account</span>
              <!-- <small v-if="hasUser">
                <strong>({{ userName }})</strong>
              </small> -->
            </router-link>
          </div>
          <div class="navbar-item is-hidden-desktop is-relative nav-item-cart--mobile">
            <a id="nav-cart-mobile" @click="handleToggleDrawer" tabindex="0" @keyup.enter="handleToggleDrawer()">
              <b-icon icon="shopping-cart" size="is-small"></b-icon>&nbsp;
              <small class="cart-count has-background-danger has-text-white has-text-weight-bold is-size-7"
                v-if="itemCount > 0">
                {{ itemCount }}
              </small>
              <span class="is-sr-only">{{ $t('general.your-cart') }}</span>
            </a>
          </div>

          <a role="button" tabindex="0" class="navbar-burger burger" aria-label="menu" aria-expanded="false"
            data-target="mainNavBar" @click="toggleMobileNav" @keydown.enter="toggleMobileNav"
            v-bind:class="{ 'is-active': showMobileNav }">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>

        <div id="mainNavBar" class="navbar-menu" v-bind:class="{ 'is-active': showMobileNav }"
          @keydown.esc="toggleMobileNav">
          <div class="navbar-start">
            <!-- no homepage & embedded & desktop-->
            <!-- <a v-if="!pendingContent && home.length == 0 && !$whitelabel.isStandalone" class="navbar-item is-hidden-touch" @click="openSearchModal"> <b-icon icon="search" size="is-small"></b-icon> &nbsp; {{ $t('general.find-vacation') }} </a> -->

            <!-- with homepage & embedded & desktop-->
            <router-link id="nav-search" v-if="!pendingContent && home.length > 0 && !$whitelabel.isStandalone"
              :to="{ name: 'search' }" class="navbar-item is-hidden-touch"> <b-icon icon="search" size="is-small"
                aria-hidden="true"></b-icon> &nbsp; {{ $t('general.find-vacation') }} </router-link>

            <!-- with homepage & standalone & desktop-->
            <router-link id="nav-search" v-if="!pendingContent && home.length > 0 && $whitelabel.isStandalone"
              :to="{ name: 'search' }" class="navbar-item is-hidden-touch"> <b-icon icon="search" size="is-small"
                aria-hidden="true"></b-icon> &nbsp; {{ $t('general.find-vacation') }}</router-link>

            <!-- no homepage & standalone & desktop -->
            <!-- <router-link v-if="!pendingContent && home.length == 0 && $whitelabel.isStandalone" :to="{name: 'search'}" class="navbar-item is-hidden-touch"> <b-icon icon="search" size="is-small"></b-icon> &nbsp; {{ $t('general.find-vacation') }}</router-link> -->

            <!-- <div class="navbar-item" v-if="!pendingContent && home.length == 0 && $whitelabel.isStandalone">
              <a @click="openSearchModal"> <b-icon icon="search" size="is-small"></b-icon> &nbsp; {{ $t('general.find-vacation') }}</a>
            </div> -->

            <div v-if="!$whitelabel.hideNavigationCategories" class="navbar-item has-dropdown is-hoverable">
              <a id="nav-countries" role="button" tabindex="0" class="navbar-link"
                @click="toggleSubNavItem('countries')" @keydown.enter="toggleSubNavItem('countries')"
                @keydown="handleKeydown($event, 'subnav-countries', 'nav-search', 'nav-themes')" aria-haspopup="true"
                aria-controls="dropdown-menu" :aria-label="$t('general.travel-destinations')">{{
                  $t('general.travel-destinations') }}</a>

              <ul id="subnav-countries" tabindex="0" class="navbar-dropdown" data-subnav="countries"
                @keydown="handleSubnavKeydown($event, 'nav-countries')">
                <li v-for="item in menu.countries" :key="item.key" class="navbar-item">
                  <router-link :to="{
                    name: 'search-by-country',
                    params: {
                      iso: item.key,
                      country: $t(`countries.${item.key}`),
                    },
                  }" @click.native="resetSearch" class="is-fullwidth is-block">
                    <span class="is-block" @click="toggleMobileNav()">{{ $t(`countries.${item.key}`) }}</span>
                  </router-link>
                </li>

                <li class="navbar-item">
                  <router-link class="is-fullwidth is-block" :to="{ name: 'hotel-map' }">{{ $t(`general.map`)
                  }}</router-link>
                </li>
              </ul>
            </div>

            <div v-if="!$whitelabel.hideNavigationCategories" class="navbar-item has-dropdown is-hoverable">
              <a id="nav-themes" role="button" tabindex="0" class="navbar-link" @click="toggleSubNavItem('themes')"
                @keydown.enter="toggleSubNavItem('themes')"
                @keydown="handleKeydown($event, 'subnav-themes', 'nav-countries', 'nav-phone')" aria-haspopup="true"
                aria-controls="dropdown-menu" :aria-label="$t('general.themes')">{{ $t('general.themes') }}</a>

              <ul id="subnav-themes" tabindex="0" class="navbar-dropdown" data-subnav="themes"
                @keydown.esc="handleSubnavKeydown($event, 'nav-themes')">
                <li v-for="item in menu.themes" :key="item.key" class="navbar-item">
                  <router-link class="is-fullwidth is-block" :to="{
                    name: 'search-by-theme',
                    params: {
                      id: item.key,
                      name: $options.filters.removeSpecialChars(item.value),
                    },
                  }" @keydown.esc="handleSubnavKeydown($event, 'nav-themes')" @click.native="resetSearch">
                    <span class="is-block" @click="toggleMobileNav()">{{ item.value }}</span>
                  </router-link>
                </li>
              </ul>
            </div>

            <div class="navbar-item" v-if="$whitelabel.short.toLowerCase() === 'ooesb' && hasPromotionDeal">
              <router-link :to="{ name: 'bargain' }" class="navbar-item">Schnäppchen</router-link>
            </div>

            <div class="navbar-item is-hidden-desktop" v-if="$whitelabel.short.toLowerCase() == 'greenstorm'">
              <a href="https://greenstorm.eu/" title="zurück zur Hauptseite"> <b-icon icon="chevron-left">
                </b-icon>zurück zur Hauptseite</a>
            </div>
          </div>

          <div class="navbar-end ">
            <!-- <div class="navbar-item has-text-weight-semibold mr-5"><b-icon icon="phone" size="is-small" custom-class="fa-flip-horizontal"></b-icon>&nbsp; +43 5372 66 888</div> -->
            <div v-if="$whitelabel.supportPhone" class="navbar-item has-text-weight-bold">
              <a id="nav-phone" :href="`tel:${$whitelabel.supportPhone}`" :aria-label="$t('general.hotline')">
                <b-icon icon="phone" size="is-small" custom-class="fa-flip-horizontal"></b-icon>
                &nbsp;&nbsp;{{ $whitelabel.supportPhone }}
              </a>
            </div>
            <div v-if="$whitelabel.supportMail" class="navbar-item has-text-weight-bold">
              <a :href="`mailto:${$whitelabel.supportMail}`" :aria-label="$t('general.email')">
                <b-icon icon="envelope" size="is-small"></b-icon>
                &nbsp;&nbsp;{{ $whitelabel.supportMail }}
              </a>
            </div>

            <RadiogutscheineHeaderContent
              v-if="$whitelabel.hasAdditionalHeaderContent && $whitelabel.short === 'radiogutscheine'" />

            <!-- no homepage & standalone & desktop -->
            <!-- <div class="navbar-item" v-if="!pendingContent && home.length == 0 && $whitelabel.isStandalone">
              <a @click="openSearchModal"> <b-icon icon="search" size="is-small"></b-icon> &nbsp; {{ $t('general.find-vacation') }}</a>
            </div> -->

            <div v-if="!$whitelabel.hideLogin" class="navbar-item is-hidden-touch">
              <router-link id="navbar-account" :to="{
                name: 'userorders',
              }">
                <b-icon v-if="!hasUser" icon="user" size="is-small"></b-icon>
                <b-icon v-if="hasUser" icon="user-cog" size="is-small"></b-icon>
                <span class="sr-only">Account</span>
                <!-- <small v-if="hasUser">
                  <strong>({{ userName }})</strong>
                </small> -->
              </router-link>
            </div>
            <div class="navbar-item is-relative is-hidden-touch">
              <a role="button" id="nav-cart" tabindex="0" @click="handleToggleDrawer"
                @keyup.enter="handleToggleDrawer()">
                <b-icon icon="shopping-cart" size="is-small"></b-icon>&nbsp;
                <small class="cart-count has-background-danger has-text-white has-text-weight-bold is-size-7"
                  v-if="itemCount > 0" aria-hidden="true"> {{ itemCount }} </small>
                <span class="is-sr-only">{{ $t('general.your-cart') }}</span>
                <i18n class="is-sr-only" v-if="itemCount > 0" path="general.cart-sr" tag="span">
                  {{ itemCount }}
                </i18n>
              </a>
            </div>

            <div class="navbar-item"
              v-if="devMode === 'development' || $whitelabel.short.toLowerCase() == 'whitelabelapi' || $whitelabel.locales != undefined">
              <b-field>
                <b-select v-model="selectedLocale" v-on="selectedLocale.set" :aria-label="$t('general.choose-language')"
                  :name="$t('general.choose-language')">
                  <!-- onchange="selectedLocale.set" -->
                  <option v-for="option in options" :value="option.value" :key="option.value">{{ option.text }}</option>
                </b-select>
              </b-field>
              <!-- <select v-model="selectedLocale">
                <option v-for="option in options" v-bind:key="option.text" v-bind:value="option.value">
                  {{ option.value }}
                </option>
              </select>-->
            </div>
          </div>
        </div>
      </div>
    </nav>

    <!-- SEARCH MODAL -->
    <b-modal :active.sync="isComponentModalActive" full-screen custom-class="search-modal">
      <MainSearch @search-completed="closeSearchModal" />
    </b-modal>
  </div>
</template>

<script>
import MainSearch from '@/components/MainSearch'
import NavHomeBrand from '@/components/Navigation/_NavHomeBrand'
import RadiogutscheineHeaderContent from '@/components/Navigation/_RadiogutscheineHeaderContent'
import { mapGetters } from 'vuex'
import contentApi from '@/api/content-api'
import focusMixin from '@/mixins/focusMixin'

export default {
  name: 'Navigation',
  components: {
    MainSearch,
    NavHomeBrand,
    RadiogutscheineHeaderContent,
  },
  props: {},
  data: function () {
    return {
      devMode: process.env.NODE_ENV,
      showMobileNav: false,
      isComponentModalActive: false,
      options: [
        {
          text: 'Deutsch',
          value: 'de',
        },
        {
          text: 'English',
          value: 'en',
        },
        {
          text: 'Italiano',
          value: 'it',
        },
      ],
      selected: 'de',
      hasPromotionDeal: false,
      // isKeyboardActive: false,
    }
  },
  mixins: [focusMixin],
  computed: {
    ...mapGetters({
      itemCount: 'itemCount',
      menu: 'menu',
      hasUser: 'hasUser',
      userName: 'userName',
      locale: 'locale',
      pendingContent: 'pendingContent',
      home: 'home',
      filter: '$_search/filter',
    }),
    selectedLocale: {
      get: function () {
        return this.locale
      },
      set: function (newValue) {
        this.$store.dispatch('changeLocale', { locale: newValue })
        this.$i18n.locale = newValue
        // sessionStorage.setItem("loc", newValue);
      },
    },
  },
  methods: {
    toggleMobileNav: function () {
      this.showMobileNav = !this.showMobileNav
    },
    toggleSubNavItem: function (item) {
      if (window.innerWidth < 1024) {
        let el = document.querySelector(`[data-subnav='${item}']`)
        el.classList.toggle('is-hidden')
      }
    },
    closeSearchModal() {
      this.isComponentModalActive = false
    },
    openSearchModal() {
      this.isComponentModalActive = true
      this.$store.dispatch('$_search/resetSearch')
    },
    handleToggleDrawer() {
      this.$store.dispatch('showDrawer')
      this.focusElement('cart')
    },
    onResize() {
      let items = document.querySelectorAll('.navbar-dropdown')

      if (window.innerWidth < 1024) {
        items.forEach(item => {
          item.classList.add('is-hidden')
        })
      } else {
        items.forEach(item => {
          item.classList.remove('is-hidden')
        })
      }
    },
    resetSearch() {
      this.$store.dispatch('$_search/resetSearch')
      // this.$store.dispatch('$_search/getProducts', this.filter)
      // window.location.href = '/'
    },
    resetSearchAndLoadProducts() {
      this.$store.dispatch('$_search/resetSearch')
      this.$store.dispatch('$_search/getProducts', this.filter)
      // window.location.href = '/'
    },
    scrollToMainContent() {
      this.$scrollTo('#main', 500, {
        offset: -500,
      })
      document.querySelector('#main').focus()
    },
    // toggleKeyboardActive() {
    //   this.isKeyboardActive = !this.isKeyboardActive
    // },
    handleKeydown(event, subnavId, prevId, nextId) {
      switch (event.key) {
        case 'Tab':
          event.preventDefault() //absolutely needed to override default tabbing and to jump to false tab
          if (event.shiftKey) {
            this.focusElement(prevId)
          } else {
            this.focusElement(nextId)
          }
          break

        case 'Enter':
        case 'ArrowDown':
          this.focusElement(subnavId)
          break

        default:
          break
      }
    },
    handleSubnavKeydown(event, triggerId) {
      if (event.key === 'Escape') {
        event.stopPropagation() // prevent the event from bubbling up to parent
        this.focusElement(triggerId)
      }
    },
  },
  async mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })

    if (this.$whitelabel.locales != undefined) {
      this.options = this.$whitelabel.locales
    }

    let promotions = await contentApi.getCurrentPromotions()

    promotions.forEach(promotion => {
      switch (promotion.type) {
        case 'Custom:deal':
          this.hasPromotionDeal = true
          break
      }
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
}
</script>

<style lang="scss">
// .navbar--firstrow {
//   border-bottom: 1px solid #000;
//   width: 100%;
//   flex-wrap: wrap;
// }

// .navbar--secondrow {
//   min-height: 0 !important; //instead of initial > ie11 support

//   .navbar-brand {
//     //min-height: 5rem !important;
//     min-height: 0 !important;

//     .navbar-item:first-child {
//       // to move burger to right
//       flex: 1;
//     }
//   }

//   .navbar-item {
//     line-height: 1.2;
//   }

//   .navbar-burger {
//     width: 3rem;
//   }

//   .is-size-7 {
//     font-size: 0.6rem !important;
//   }
// }

// .logo-coop {
//   background-color: #fff;
//   width: 152px;
//   max-height: 50px !important;
//   padding: 0.3rem 0.5rem;
// }

.navbar-menu {
  z-index: 9999;
}

.navbar .navbar-burger {
  height: 4.5rem;

  @media (width < 1024px) {
    margin-left: initial
  }
}

.navbar-brand__logo {
  max-height: none !important;
  width:
    /*50vw*/
    40vw;
  max-width: 250px;
}

.search-modal.is-full-screen {
  >.animation-content {
    //background-color: rgba(#95c11f, 0.9) !important; //overwrite bulma styles
    max-height: 104vh !important; //overwrite bulma styles;
  }

  >.modal-background {
    display: none;
  }
}

.skip-to-main {
  transform: translateX(1rem);

  &:focus {
    transform: translateX(1rem) translateY(1rem);
  }
}
</style>
